import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SignoGecrosAfiliado } from 'src/app/interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';
import { User } from 'src/app/interfaces/interface-bakend/seguridad/users/user.interface';
import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
import { UsuarioService } from 'src/app/services/shared/usuario.service';
import { PopUpModalCustomService } from '@services/shared/popup-modal-custom.service';
import { PersonasListadoComponent } from '../personas-listado/personas-listado.component';

@Component({
    selector: 'app-modal-detalle-gecros',
    templateUrl: './modal-detalle-gecros.component.html',
    styleUrls: ['./modal-detalle-gecros.component.scss'],
})
export class ModalDetalleGecrosComponent implements OnInit, OnDestroy {
    gecrosAfiliado: SignoGecrosAfiliado;
    flagLoad = false;
    btnSincronizar = false;
    progressBar = false;

    constructor(
        public dialogRef: MatDialogRef<PersonasListadoComponent>,
        private gecrosAfiliadosService: GecrosAfiliadosService,
        private usuarioService: UsuarioService,
        private modalCustom: PopUpModalCustomService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnDestroy(): void {
        this.modalCustom.cerrar();
    }

    ngOnInit(): void {
        this.getAfiliado();
    }

    // =====================================================
    // Datos
    // =====================================================

    async getAfiliado(): Promise<void> {
        try {
            const resp = await this.gecrosAfiliadosService.getAfiliadoByIdentificacion(
                this.data.identificacion
            );
            this.gecrosAfiliado = resp.data[0];
        } catch (error) {
            console.error('Error al obtener el afiliado de Gecros:', error);
            this.gecrosAfiliado = undefined;
        } finally {
            this.flagLoad = true;
        }
    }

    convertirFecha(fechaNacimientoStr: string): string {
        const partesFecha = fechaNacimientoStr.split('/');
        const dia = partesFecha[0];
        const mes = partesFecha[1];
        const anio = partesFecha[2];

        const fechaNacimiento = new Date(Date.UTC(+anio, +mes - 1, +dia));

        return fechaNacimiento.toISOString().split('T')[0];
    }

    // =====================================================
    // Sincronización
    // =====================================================

    sincronizarDatosGecros(): void {
        if (!this.gecrosAfiliado) {
            return;
        }
        this.modalCustom.abrirPopup({
            tipo: 'warning',
            titulo: 'Sincronizar datos',
            mensaje: '¿Confirma sincronizar los datos de Gecros con Signo Médico?',
            textoBoton: 'Sí, sincronizar',
            textoBotonCancelar: 'Cancelar',
            accionConfirmar: () => this.updateDataGecros(),
        });
    }

    async updateDataGecros(): Promise<void> {
        this.btnSincronizar = true;
        this.progressBar = true;

        try {
            // separo los nombres por espacio y los guardo en un arreglo
            const nombresAfiliado: string[] = this.gecrosAfiliado?.nombreAfiliado
                .trim()
                .split(/\s+/);

            // guarda solo el apellido
            const apellido = nombresAfiliado.pop().trim();

            // guardo los nombres solamente
            const nombresSinApellido = nombresAfiliado.join(' ');

            const fechaNacimientoISOStr = this.convertirFecha(
                this.gecrosAfiliado.fechaNacimiento
            );

            const updateUser: User = {
                nombrePersona: nombresSinApellido,
                apellidoPersona: apellido,
                birth: fechaNacimientoISOStr,
                signoGecrosAfiliado: this.gecrosAfiliado,
                _id: this.data._id,
            };

            await this.usuarioService.updateOne(updateUser);

            this.modalCustom.abrirPopup({
                tipo: 'success',
                titulo: 'Sincronizado',
                mensaje: 'Los datos se sincronizaron correctamente.',
                textoBoton: 'Entendido',
            });
        } catch (error) {
            this.modalCustom.abrirPopup({
                tipo: 'error',
                titulo: 'Error al modificar',
                mensaje: 'No se pudieron sincronizar los datos. Intentá nuevamente.',
                textoBoton: 'Entendido',
            });
            this.btnSincronizar = false;
        } finally {
            this.progressBar = false;
        }
    }
}
